module.exports = __webpack_public_path__ + "img/kendo-k-i-track-changes-enable@3x.5aefff52.png";